export default {"src":"/_next/static/image/src/images/caution.976aa8fcd73212880299b50ae55e4e87.svg","height":19,"width":22};